__turbopack_context__.v({
  "button": "CompanyButton-module-scss-module__xRFQxG__button",
  "fallback": "CompanyButton-module-scss-module__xRFQxG__fallback",
  "label": "CompanyButton-module-scss-module__xRFQxG__label",
  "logo": "CompanyButton-module-scss-module__xRFQxG__logo",
});
